var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconMore = function SvgIconMore(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 16,
    viewBox: "0 0 4 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "More ver.",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0917972 13.7273C0.0917972 14.7816 0.946527 15.6364 2.00089 15.6364C3.05525 15.6364 3.90998 14.7816 3.90998 13.7273C3.90998 12.6729 3.05525 11.8182 2.00089 11.8182C1.49448 11.8179 1.00872 12.0189 0.650637 12.377C0.292551 12.7351 0.0915079 13.2209 0.0917972 13.7273ZM0.0917972 8.00001C0.0917972 9.05437 0.946527 9.9091 2.00089 9.9091C3.05525 9.9091 3.90998 9.05437 3.90998 8.00001C3.90998 6.94565 3.05525 6.09092 2.00089 6.09092C1.49448 6.09063 1.00872 6.29167 0.650637 6.64976C0.292551 7.00785 0.0915079 7.4936 0.0917972 8.00001ZM0.0917972 2.27274C0.0917972 3.3271 0.946527 4.18183 2.00089 4.18183C3.05525 4.18183 3.90998 3.3271 3.90998 2.27274C3.90998 1.21838 3.05525 0.363648 2.00089 0.363648C1.49448 0.363358 1.00872 0.564401 0.650637 0.922488C0.292551 1.28057 0.0915079 1.76633 0.0917972 2.27274Z",
    fill: "#444A58"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconMore);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/icon-more.1814b1199f7557e21a52572259c516b5.blank.svg";